import React from 'react'

import {FiFacebook, FiLinkedin, FiInstagram} from 'react-icons/fi'

function Footer() {
  return (
    <div className="container-fluid footer bg-dark text-light">
      <footer className="page-footer font-small blue">
        <div className="footer-copyright text-center d-flex flex-column align-items-center justify-content-around m-2 p-1">
          <div>© 2020 Copyright: online.alif</div>
          <div>
            <FiFacebook className="m-2 icon-fb" size="20" />
            <FiInstagram className="m-2 icon-in" size="20" />
            <FiLinkedin className="m-2 icon-lk" size="20" />
          </div>
        </div>
      </footer>
    </div>
  )
}
export default Footer
